import { apiBaseUrl } from 'yxt-biz-pc/packages/api';

export default {
  getTrainingMapsList(data, params) {
    return apiBaseUrl.post('talent/open/trainmap/list', data, { params: params });
  },
  getSpTrainingmapsList(data, params) {
    return apiBaseUrl.post('sptalent/open/trainmap/list', data, { params: params });
  }
};
